/* eslint-disable react/no-unstable-nested-components */
import React from "react";
import DataTable from "react-data-table-component";
import { FaAngleDown, FaAngleRight } from "react-icons/fa";
import { formatarData } from "../../../../components/Formatters/DateTime";
import PatDetalhe from "./PatDetalhe";

const PatCard = ({ processoAdministrativoTributario }) => {
  const columns = [
    {
      name: "PAT",
      selector: "pat",
      center: true,
      sortable: true,
    },
    {
      name: "Data do Processo",
      cell: (row) => formatarData(row.data_Processo, "dd/MM/yyyy"),
      center: true,
    },
    {
      name: "URT",
      selector: "urt",
      center: true,
    },
    {
      name: "Situação",
      selector: "situacao",
      center: true,
    },
    {
      width: "55px",
      selector: (row) => (row.expanded ? <FaAngleDown /> : <FaAngleRight />),
    },
  ];

  return (
    <div className="col-lg-12">
      <div className="card shadow mb-1">
        <div className="card-header">
          <b>Processo Administrativo Tributário - PAT</b>
        </div>
        <div className="card-body">
          <center>
            <DataTable
              columns={columns}
              data={processoAdministrativoTributario}
              expandableRowsHideExpander
              expandOnRowClicked
              expandableRows
              expandableRowsComponent={PatDetalhe}
            />
          </center>
        </div>
      </div>
    </div>
  );
};

export default PatCard;
